var map = {
	"./ch1.png": 1704,
	"./ch2.png": 3667,
	"./ch3.png": 1754,
	"./ch4.png": 2181,
	"./ch5.png": 6268,
	"./ch6.png": 3847,
	"./ch7.png": 4350,
	"./chamoozesh.png": 6423,
	"./chifilm.png": 7022,
	"./chmostanad.png": 5542,
	"./chnamayesh.png": 6139,
	"./chnasim.png": 3689,
	"./chnews.png": 1260,
	"./chofogh.png": 1610,
	"./chomid.png": 2746,
	"./chpouya.png": 8987,
	"./chsalamat.png": 2748,
	"./chsepehr.png": 1538,
	"./chtamasha.png": 3502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3735;